import { Fragment } from 'react';
import type { IBreadcrumbs } from '../../types/breadcrumbs';
import { SlashForward } from './../../assets/Icons';
import { Button } from '../Button';
import styles from "./breadcrumbs.module.scss";

export const Breadcrumbs = ({
  linksProps
}: IBreadcrumbs) => {

  return (
    linksProps &&
    <div className={styles["breadcrumbs"]}>
      {
        linksProps.map((btn, index) => {
          return (
            <Fragment key={`breadcrumb-item-${index}`}>
              <Button
                size={btn.size || 'sm'}
                color={btn.active ? 'primary' : 'secondary'}
                variant='link'
                text={btn.text}
                onClickHandler={() => btn.active && btn.onClickHandler?.(btn.text)}
              />

              {
                index + 1 !== linksProps.length &&
                <div className={styles["breadcrumbs__slash-icon"]}>
                  {SlashForward}
                </div>
              }
            </Fragment>
          )
        })
      }
    </div>
  )
};